export default {"src":"/_next/static/media/spares.10757460.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};